import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import BasicModal from '__components/Modals/presets/BasicModal';
import { MarketplacePlugin } from '__pages/Marketplace/types';
import { useTranslation } from 'react-i18next';

export const ConfirmationModal = ({
  confirmationModalProps,
  installedPlugin,
}: {
  confirmationModalProps: any;
  installedPlugin: MarketplacePlugin;
}) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      {...confirmationModalProps}
      heading={t('Confirm Disable')}
      buttonText={t('Disable')}
    >
      <div>
        <Typography>
          {t(
            '{{name}} will stop for everyone in your business. Settings and secrets are kept, and you can enable it again at any time.',
            {
              name: installedPlugin?.name,
            }
          )}
        </Typography>
        <Spacer size={5} />
      </div>
    </BasicModal>
  );
};
